import { TEST_IDS } from '@va/constants';
import dayjs from 'dayjs';
import { useDateInputContext } from './DateInputContext';
import { PickerButton } from './PickerButton';
import { DateInputView } from './types';

export const Year = () => {
  const {
    pickerConfig: { yearsCount },
    yearViewLowestYear,
    setYear,
    setView,
    isDateInRange,
  } = useDateInputContext();

  return (
    <div className='grid grid-cols-2 gap-1' data-tesid={TEST_IDS.generic.datePicker.yearsPanel}>
      {Array.from({ length: yearsCount }, (_, i) => yearViewLowestYear + i).map((year) => {
        const date = dayjs().year(year).month(0).day(1);
        const isDisabled = !isDateInRange(date, 'year');

        return (
          <PickerButton
            onClick={() => {
              setYear(year);
              setView(DateInputView.Day);
            }}
            className='font-medium!'
            data-testid={TEST_IDS.generic.buttons.select}
            disabled={isDisabled}
          >
            {year}
          </PickerButton>
        );
      })}
    </div>
  );
};
